import { ProviderAccount } from '@biz-action/system-actions/account-overview.actions';
import {
	GetPagePermissionsSuccess,
	SetCurrentUser,
	SetUserRolePermissonsSuccessful,
} from '@biz-action/system-actions/current-user-system.actions';
import { socialLinkAccount } from '@biz-action/system-actions/social-account.action';
import { authenticationAccount } from '@biz-action/user-actions/account-actions';
import { authentication } from '@biz-action/user-actions/auth-login.actions';
import { CurrentUserState } from '@biz-store/auth/states/current-user.state';
import { createReducer, on } from '@ngrx/store';

const initialState: CurrentUserState = {
	id: 0,
	uuid: '',
	name: '',
	email: '',
	locale: '',
	permissions: [],
	roles: [],
	branch: {
		id: 0,
	},
	linked_to_facebook: false,
	selectedLanguage: '',
	linkAccount: [],
	ListTenantAccount: [],
};

export const reducer = createReducer(
	initialState,
	on(SetCurrentUser, (state, action) => {
		state = {
			...state,
			...action.payload.user,
			// TODO: remove hack thats exclude permissions
			permissions: [],
		};
		return state;
	}),
	on(SetUserRolePermissonsSuccessful, GetPagePermissionsSuccess, (state, action) => {
		// state.permissions = [...new Set([...state.permissions, ...action.payload])];
		state = {
			...state,
			permissions: [...state.permissions, ...action.payload],
		};
		return state;
	}),

	on(ProviderAccount.getproviderlistsuccess, (state, action) => {
		state = { ...state, linkAccount: action.payload };
		return state;
	}),

	on(authenticationAccount.loadsubdomainlistsuccess, (state, action) => {
		state = {
			...state,
			ListTenantAccount: [
				// ...state.ListTenantAccount,
				...action.payload.map((i) => ({
					...i,
					companyName: i.name,
					subdomain: i.domain,
					// get matching server and token from existing state account which have been set
					server: state.ListTenantAccount?.find((j) => j.subdomain === i.domain)?.server || '',
					token: state.ListTenantAccount?.find((j) => j.subdomain === i.domain)?.token || '',
				})),
			],
		};
		return state;
	}),

	on(authentication.authtokensuccess, (state, action) => ({
		...state,
		ListTenantAccount: [...action.payload],
	})),

	on(authentication.logoutaccountsuccesss, () => initialState),
	// on(authentication.loginsuccess, (state, action) => ({
	// 	...state,
	// 	ListTenantAccount: action.payload.map((i) => ({
	// 		...i,
	// 		companyName: i.company_name,
	// 		domain: i.subdomain,
	// 		username: i.user.name,
	// 	})),
	// })),
	on(socialLinkAccount.sociallinksuccess, (state, action) => {
		let linkAccount = [...state.linkAccount, action.payload.identity_provider];
		return {
			...state,
			linkAccount: linkAccount,
		};
	}),
	on(socialLinkAccount.socialunlinksuccess, (state, action) => {
		let linkAccount = state.linkAccount?.filter((i) => i.id !== action.payload.social_user.id);
		return {
			...state,
			linkAccount: linkAccount,
		};
	}),
);
